/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { BillerBaseLoggedInGetService } from 'src/app/shared/services/biller-base-logged-in-get.service';
import constantURL from 'src/app/shared/constantURL';
@Injectable({
  providedIn: 'root',
})
export class GetPriceDetailsService extends BillerBaseLoggedInGetService {
  public setPath(id: string) {
    this._path = constantURL.BillPayments.BILLER_SERVICE.getPrice + id;
  }
}
